import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { FileType } from 'src/service/file-save.service';
import { ConfigurationManagementService } from '../../../service/configuration-management.service';
import { LanguageManagementService } from '../../../service/language-management.service';
import { KeyValues3, KeyValueSet, LanguageKeyType, LocalService, PageKey, PageKeyAccessType, Status, TriggeredEvent, UserGuideType, Wrapper3 } from '../../../service/local.service';

@Component({
  selector: 'app-guide-config',
  templateUrl: './guide-config.component.html',
  styleUrls: ['./guide-config.component.scss']
})
export class GuideConfigComponent implements OnInit {
  pageKeys: KeyValueSet[]; isActive = false; isManualDownloadUpload = true;
  wrapper: Wrapper3; selectedPageKey = "0-0"; lstSectionConfigKeys: string[] = ["guide"]; maxBodyHeight = 0;
  constructor(public localService: LocalService, private cdr: ChangeDetectorRef, private activeModal: NgbActiveModal, private languageManagementService: LanguageManagementService, private configurationManagementService: ConfigurationManagementService) { }

  ngOnInit(): void {
    this.languageManagementService.ensureLanguageSectionKeys(this.lstSectionConfigKeys);
    this.onLoad();
  }

  onLoad() {
    this.configurationManagementService.getGuideTitlesToDisplay(true).subscribe(result => {
      this.pageKeys = result;
      if (this.selectedPageKey == "0-0") {
        this.newWrapper();
      } else {
        this.onGetGuide();
      }
    });
  }

  ngAfterViewChecked() {
    this.maxBodyHeight = this.localService.onGetMaxModalBodyHeight(-20);
    this.cdr.detectChanges();
  }

  onGetGuide() {
    let temp = this.selectedPageKey.split("-");
    this.configurationManagementService.getGuide(parseInt(temp[0]), parseInt(temp[1])).subscribe(result => {
      if (result && result.content) {
        this.wrapper = result;
      } else {
        this.newWrapper();
      }
      this.isActive = this.wrapper.content.v2 == '1';
    });
  }

  onDownLoadFile() {
    // if (this.isManualDownloadUpload) {
    //   this.configurationManagementService.downloadGuidesManual(this.pageKey).subscribe(result => {
    //     this.localService.onDownloadFile(result, 'ExtractUserGuide' + PageKey[this.pageKey], FileType.BAT);
    //   });
    // }
  }

  newWrapper() {
    this.wrapper = {
      content: { key: '', v1: '', v2: '0', v3: "0" } as KeyValues3,
      languageContents: null
    } as Wrapper3;
  }

  onPopupClose() {
    this.activeModal.close({ event: TriggeredEvent.Close });
  }

  onAction(index: number, key?: string) {
    switch (index) {
      case 1: {
        let temp = this.selectedPageKey.split("-");
        this.wrapper.content.v1 = temp[1];
        this.wrapper.content.v2 = this.isActive ? '1' : '0';
        this.wrapper.content.v3 = temp[0];
        this.configurationManagementService.saveGuide(this.wrapper).subscribe(result => {
          this.localService.showInformationByStatus(result.status);
          if (result.status == Status.Success) {
            this.wrapper.content.key = result.id;
          }
        });
      } break;
      case 2: {
        this.configurationManagementService.copyAllGuideContentsToEnglish(key).subscribe(result => {
          this.localService.showInformationByStatus(result.status);
        });
      } break;
      case 3: {
        this.languageManagementService.refreshSearchValueBulk(LanguageKeyType.UserGuideTitle).subscribe(result => {
          this.localService.showInformationByStatus(result);
        });
      } break;
    }
  }

  onEmptyLanguageContainerAdded(languageContents: any) {
    this.wrapper.languageContents = languageContents;
  }
}
